export default __webpack_public_path__ + "687af9460db492c443b4cd1e4c5a7c64.png";